import request from '@/utils/request'

export function getFleetCardVehicles(branchId, size, page, find, branchIdQuery) {
  return request({
    url: `/mypetrol/fleetcardvehicles/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      branchId: branchIdQuery
    }
  })
}

export function getFleetCardVehicleById(branchId, id) {
  return request({
    url: `/mypetrol/fleetcardvehicles/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findFleetCardVehicles(branchId, find) {
  return request({
    url: `/mypetrol/fleetcardvehicles/list/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function reportingFleetCardVehicles(branchId, dates, dateType) {
  return request({
    url: `/mypetrol/fleetcardvehicles/reporting/${branchId}`,
    method: 'get',
    params: {
      find: find,
      startDate: dates,
      dateType: dateType
    }
  })
}

export function createFleetCardVehicles(branchId, data) {
  return request({
    url: `/mypetrol/fleetcardvehicles/create/${branchId}`,
    method: 'post',
    data
  })
}

export function addFleetCardVehicles(branchId, data) {
  return request({
    url: `/mypetrol/fleetcardvehicles/add/${branchId}`,
    method: 'post',
    data
  })
}

export function duplicateFleetCardVehicles(branchId, id) {
  return request({
    url: `/mypetrol/fleetcardvehicles/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updateFleetCardVehicles(branchId, id, data) {
  return request({
    url: `/mypetrol/fleetcardvehicles/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function activeTickFleetCardVehicles(branchId, id, data) {
  return request({
    url: `/mypetrol/fleetcardvehicles/activeTick/${branchId}/${id}`,
    method: 'post',
    data
  })
}

export function savePercentageFollowUpFleetCardVehicles(branchId, data) {
  return request({
    url: `/mypetrol/fleetcardvehicles/savePercentageFollowUp/${branchId}`,
    method: 'post',
    data
  })
}

export function personalExcelFleetCardVehicles(branchId, secondBranchId) {
  return request({
    url: `/mypetrol/fleetcardvehicles/personalExcel/${branchId}`,
    method: 'get',
    params: {
      branchId: secondBranchId
    },
    responseType: 'blob'
  })
}

export function downloadExcelBFleetCardVehicles(branchId, dates, dateType) {
  return request({
    url: `/mypetrol/fleetcardvehicles/downloadExcelB/${branchId}`,
    method: 'get',
    params: {
      startDate: dates,
      dateType: dateType
    },
    responseType: 'blob'
  })
}

export function removeFleetCardVehicles(branchId, id) {
  return request({
    url: `/mypetrol/fleetcardvehicles/id/${branchId}/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/mypetrolFleetCardVehicles.js